import { render, staticRenderFns } from "./RewardsHome.vue?vue&type=template&id=7c20bfcc"
import script from "./RewardsHome.vue?vue&type=script&lang=js"
export * from "./RewardsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports